const translations = {
  ko: {
    home: '홈',
    adminLogin: '관리자 로그인',
    username: '아이디',
    password: '비밀번호',
    keepLoggedIn: '로그인 유지',
    login: '로그인',
    findUsername: '아이디 찾기',
    findPassword: '비밀번호 찾기',
    signUp: '회원가입',
    mainTitle: '관리자 로그인',
    loginSuccess: '로그인 성공!',
    loginFailed: '로그인에 실패했습니다.',
    userNotFound: '사용자를 찾을 수 없습니다.',
    incorrectPassword: '비밀번호가 올바르지 않습니다.',
    storeDeactivated: '영업중지된 상점입니다. 상점지원센터에 문의해주세요(070-4010-8203).',
    storeSupport: '상점 지원',
    serviceIntro: '서비스 소개',
    loginMaintain: '로그인유지',
    loginId: '아이디',
    loginPassword: '비밀번호',
    loginButton: '로그인',
    logout: '로그아웃',
    myPage: '마이페이지',
    giftManagement: '기프트 관리',
    userManagement: '관리자 정보 관리',
    staffManagement: '직원 관리',
    storeManagement: '상점 정보 관리',
    customerManagement: '고객 정보 관리',
    serviceInquiry: '서비스 문의',
    searchPeriod: '조회기간',
    giftId: '기프트 아이디',
    descendingOrder: '내림차순',
    ascendingOrder: '오름차순',
    saleQuantity: '판매수량',
    state: '상태',
    beforeSale: '판매전',
    inSale: '판매중',
    endSale: '판매종료',
    saleRegister: '판매예정',
    saleStart: '판매시작',
    salePause: '판매중지',
    saleEnd: '판매종료',
    saleCancel: '판매취소',
    registrationDate: '등록일',
    saleDate: '판매일',
    search: '검색',
    reset: '초기화',
    giftImage: '기프트 이미지',
    price: '가격',
    remainingCount: '남은수량',
    totalIssued: '총발행수량',
    totalSalesAmount: '누적판매금액',
    editOrSalesStatus: '수정/판매현황',
    edit: '수정',
    giftCancelSale: '판매취소',
    giftToList: '목록으로',
    giftSave: '저장',
    salesStatus: '판매현황',
    totalCount: '총건수',
    count: '건',
    registerGift: '기프트 등록',
    currency: '원',
    stateDesc: {
      판매등록: '판매예정',
      판매예정: '판매예정',
      판매시작: '판매시작',
      판매중지: '판매중지',
      판매일시중지: '판매일시중지',
      판매종료: '판매종료',
      판매취소: '판매취소',
      환불요청: '환불요청',
      환불완료: '환불완료',
      미수신: '미수신',
      미사용: '미사용',
      사용완료: '사용완료',
      기사용오류: '기사용오류',
      유효기간오류: '유효기간오류',
    },
    payMethodDesc: {
      토스페이: '토스페이',
      네이버페이: '네이버페이',
      카카오페이: '카카오페이',
      페이코: '페이코',
      신용카드: '신용카드',
      계좌이체: '계좌이체',
    },
    currentPassword: '기존 비밀번호',
    newPassword: '신규 비밀번호',
    confirmNewPassword: '신규 비밀번호 확인',
    changePassword: '비밀번호 변경',
    name: '이름',
    birthday: '생년월일',
    gender: '성별',
    male: '남자',
    female: '여자',
    email: '이메일',
    requestEmailAuth: '인증번호받기',
    validateEmailAuth: '인증하기',
    phoneNumber: '휴대폰번호',
    requestSMSAuth: '인증번호받기',
    validateSMSAuth: '인증하기',
    address: '주소',
    modificationDate: '수정일시',
    userWithdrawal: '회원탈퇴',
    cancel: '취소',
    save: '저장',
    authCode: '인증번호',
    storeId: '상점 아이디',
    storeName: '상점명',
    representativeName: '대표자명',
    storeUsageState: '사용/게시 상태',
    storeStateTemp: '임시',
    storeStatePublished: '게시',
    storeLogo: '상점 로고/사진',
    bizCertFile: '사업자등록증',
    bizCertFileUploadedLabel: '등록된 파일',
    bizCertFileNote:
      '※ PDF 또는 이미지(jpg,jpeg,png) 파일 첨부 가능, 10MByte까지 업로드 할 수 있습니다.',
    bizCertFileSizeError: '사업자등록증 파일 크기는 10MByte를 초과할 수 없습니다.',
    storeNaverUrl: '네이버 공유 링크',
    storeKakaoUrl: '카카오 공유 링크',
    storeInstagramUrl: '인스타그램 공유 링크',
    openLink: '링크 열기',
    storeBizType: '사업자 유형',
    storeBizTypeIndividual: '개인',
    storeBizTypeSoleProprietor: '개인사업자',
    storeBizTypeCorporation: '법인사업자',
    storeBizNumberCheck: '사업자 등록번호 조회',
    storeBizNumberChecking: '조회중...',
    storeBizNumberCheckSuccess: '사업자 등록번호 조회가 완료되었습니다.',
    storeBizNumberCheckEmpty: '사업자등록번호를 3-2-5 자리로 입력해주세요.',
    storeBizNumberCheckFail:
      '사업자 등록번호 조회에 실패했습니다. 다시 시도해주세요.',
    storeBizNumberCheckRequired: '사업자 등록번호 조회를 완료해주세요.',
    noDashPlaceholder: '"-" 없이 숫자만 입력해주세요.',
    uploadFileNote:
      '※ jpg,jpeg,gif,png 파일 첨부 가능, 1개 파일을 3MByte까지 업로드 할 수 있습니다.',
    giftUploadFileNote:
      '※ jpg,jpeg,gif,png 파일 첨부 가능, 큰 사진은 자동으로 줄여서 올라갑니다. (GIF는 3MByte까지)',
    phoneSameAsAdmin: '관리자 정보와 동일',
    selectBank: '입금받을 은행',
    bankAccountNumber: '입금받을 계좌번호',
    accountHolder: '예금주',
    accountValidation: '계좌 실명 조회',
    giftQR: '선물하기 QR 코드',
    storeQrStickerCount: '선물하기 QR 부착 개수',
    storeAcrylicInstallCount: '아크릴 설치 개수',
    giftProductQrLabel: '기프트 상세 QR 코드',
    giftProductQrDescZero:
      '0원 축제 쿠폰: 당첨자가 이 QR을 스캔하면 기프트 상세 → 「이벤트 쿠폰 받기」로 축제 쿠폰함에 적재됩니다. 별도 진입 QR·사전 재고 적재는 사용하지 않습니다.',
    downloadQR: '선물하기 QR코드 저장하기',
    printQR: '선물하기 QR코드 프린트하기',
    delete: '삭제',
    inquiryType: '질문유형',
    questionTitle: '글 제목',
    author: '작성자',
    select: '선택',
    title: '글 제목',
    titleContent: '제목+내용',
    content: '내용',
    public: '공개',
    private: '비공개',
    answer: '답변',
    askQuestion: '질문하기',
    no: 'No',
    questionType: '질문유형',
    qnaCategoryDesc: {
      '서비스 관련': '서비스 관련',
      '기프트 발행': '기프트 발행',
      '기프트 구매선물': '기프트 구매선물',
      '기프트 사용검증': '기프트 사용검증',
      입금: '입금',
      환불: '환불',
      기타: '기타',
    },
    giftName: '기프트 명',
    category: '카테고리',
    giftPhoto: '기프트 사진',
    giftAd: '기프트 설명',
    salePeriod: '판매기간',
    validityPeriod: '유효기간',
    totalIssuedQuantity: '총발행수량',
    autoTransferTime: '자동송금시간',
    registrationDateTime: '등록일시',
    createAdText: '광고문구 생성',
    giftAdSelect: '광고문구를 선택해주세요',
    giftUnlimited: '무기한',
    purchaseAfter: '구매후',
    month: '개월',
    day: '일',
    unlimited: '무제한',
    usageAfter: '사용후',
    hour: '시간',
    register: '등록',
    searchCondition: '--조회조건--',
    searchConditionLabel: '검색 조건',
    searchKeyword: '검색어',
    searchFieldNameDefault: '성명 (기본)',
    ageGroup10s: '10대',
    ageGroup20s: '20대',
    ageGroup30s: '30대',
    ageGroup40s: '40대',
    ageGroup50plus: '50대 이상',
    ageGroup: '연령대',
    loading: '불러오는 중...',
    paymentDate: '결제일',
    usageDate: '사용일',
    depositDate: '입금일',
    refundRequestDate: '환불요청일',
    refundCompletionDate: '환불완료일',
    searchOrder: '--조회일--',
    paymentInfo: '--결제수단--',
    paymentMethod: '결제수단',
    tossPay: '토스페이',
    naverPay: '네이버페이',
    kakaoPay: '카카오페이',
    payco: '페이코',
    creditCard: '신용카드',
    bankTransfer: '계좌이체',
    card: '카드',
    simplePayment: '간편결제',
    usageInfo: '--사용정보--',
    unused: '미사용',
    unreceived: '미수신',
    paid: '입금',
    unpaid: '미입금',
    completed: '사용완료',
    errorUsed: '기사용오류',
    expired: '유효기간오류',
    depositInfo: '--입금정보--',
    notDeposited: '미입금',
    deposited: '입금완료',
    refundInfo: '--환불정보--',
    refundRequest: '환불요청',
    refundRequestCancel: '환불요청취소',
    refundCompleted: '환불완료',
    giftSerial: '기프트 시리얼',
    giftSerialOrName: '기프트 시리얼 또는 상품명',
    gifter: '선물한 사람',
    giftee: '선물받은 사람',
    paymentDetails: '결제수단',
    usageDetails: '사용정보',
    depositDetails: '입금정보',
    refundDetails: '환불정보',
    paymentAmount: '결제금액',
    usageAmount: '사용금액',
    depositAmount: '입금금액',
    refundAmount: '환불금액',
    serviceFee: '서비스이용료',
    saleAmount: '판매금액',
    stopReason: '중지사유',
    stopDateTime: '중지일시',
    inputErrorStopReason: '입력오류: 중지사유를 입력해 주세요',
    giftModifyDelete: '기프트 수정/삭제',
    saleStartBtn: '판매시작하기',
    salesStop: '판매중지하기',
    salesPauseBtn: '판매일시중지하기',
    salesResume: '판매재개하기',
    soldAmount: '누적판매금액',
    soldQuantity: '누적판매수량',
    status: '상태',
    salesState: '상태',
    giftState: '상태',
    Marketing: '마켓팅 관리',
    pushAlarmTestMenu: '푸시알림 테스트',
    writer: '작성자',
    fileUpload: '파일 업로드',
    publicType: '공개유형',
    note: '※ 고객님의 소중한 의견을 수렴하는 공간입니다. 내기프트에 바라는 내용을 등록해 주세요. 상업적 글이나 무고, 욕설, 비방, 개인정보 등과 관련된 글을 올리는 경우 삭제 될 수 있습니다.',
    selectCategory: {
      serviceRelated: '서비스 관련',
      giftIssuance: '기프트 발행',
      giftPurchasePresent: '기프트 구매선물',
      giftUsageVerification: '기프트 사용검증',
      deposit: '입금',
      refund: '환불',
      others: '기타',
      '쇼핑,유통': '쇼핑,유통',
      제조업: '제조업',
      '협회,단체': '협회,단체',
      '스포츠,오락': '스포츠,오락',
      한식: '한식',
      '여행,명소': '여행,명소',
      음식점: '음식점',
      '생활,편의': '생활,편의',
      '전문,기술서비스': '전문,기술서비스',
      '카페,디저트': '카페,디저트',
      '서비스,산업': '서비스,산업',
      '건강,의료': '건강,의료',
      '교육,학문': '교육,학문',
      건설업: '건설업',
      '사회,복지': '사회,복지',
      '직업,기술교육': '직업,기술교육',
      '육류,고기요리': '육류,고기요리',
      '병원,의원': '병원,의원',
      '스포츠,레크레이션교육': '스포츠,레크레이션교육',
      '임대,대여': '임대,대여',
    },
    length: '글자 수',
    quantity: '개',
    movetogiftpage: '선물하기 페이지 이동하기',
    movetoGiftProductPage: '기프트 상세 페이지 이동하기',
    refundHistory: '환불 내역',
    refundType: '환불 유형',
    refundTypeGifter: '구매자 환불',
    refundTypeGiftee: '수신자 환불',
    refundTypeOwner: '상점주 환불',
    refundFilterAll: '전체',
    bank: '은행',
    accountNo: '계좌번호',
    cancelPayment: '결제 취소',
    total: '총건수',
    confirmRefund: '환불 내용 확인',
    refundAmountLabel: '환불 금액',
    cancelReason: '환불 사유',
    cancelPaymentSuccess: '결제가 취소되었습니다.',
    cancelPaymentError: '결제 취소에 실패했습니다.',
    loginExpired: '유효기간이 만료되었으니 다시 로그인해주세요',
    sortOrder: '정렬 순서',
    ascending: '오름차순',
    descending: '내림차순',
    close: '닫기',
    pushalarm: '푸시 알림',
    confirmSaleStart: '정말 판매시작 하시겠습니까?',
    confirmResume: '정말 재개 하시겠습니까?',
    confirmPause: '정말 중지 하시겠습니까?',
    giftSaleEndNoModify: '판매종료(판매취소)된 기프트는 수정할 수 없습니다.',
    giftSaleStartDateInvalid:
      '판매시작일은 오늘 또는 이후 날짜만 설정할 수 있습니다.',
    confirmModify: '정말 수정 하시겠습니까?',
    confirmModifyFuture:
      '기존 기프트는 {oldUntil}까지 판매 후 종료되고,\n수정한 내용은 {newStart}부터 판매됩니다.\n수정하시겠습니까?',
    confirmSaleStartReplace:
      '정말 판매시작 하시겠습니까?\n같은 이름으로 판매중인 이전 버전이 있으면 함께 판매취소됩니다.',
    confirmModifyTodayReplace:
      '판매시작일을 오늘로 설정하면 저장하는 즉시 판매가 시작됩니다.\n같은 이름으로 판매중인 이전 버전이 있으면 함께 판매취소됩니다.\n오늘 바로 판매를 시작하시겠습니까?',
    confirmModifyToday:
      '판매시작일을 오늘로 설정하면 저장하는 즉시 수정한 내용으로 판매가 시작되고,\n기존 기프트는 판매취소됩니다.\n오늘 바로 판매를 시작하시겠습니까?',
    confirmRegisterToday:
      '판매시작일을 오늘로 설정하면 등록하는 즉시 판매가 시작됩니다.\n오늘 바로 판매를 시작하시겠습니까?',
    confirmModifyTodayWithPending:
      '판매시작일을 오늘로 설정하면 저장하는 즉시 수정한 내용으로 판매가 시작되고, 기존 기프트는 판매취소됩니다.\n수정한 내용은 {until}까지 판매되고, {pendingStart}부터는 예약된 내용으로 판매됩니다.\n오늘 바로 판매를 시작하시겠습니까?',
    confirmCancelSale:
      '정말 판매취소 하시겠습니까?\n기프트를 판매취소할 경우 다시는 사용할 수 없습니다.',
    requestError:
      '요청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    imageSizeError: '이미지 파일 크기는 3MByte를 초과할 수 없습니다.',
    giftNameRequired: '기프트명을 입력해 주세요.',
    giftNameMaxLength: '기프트명은 최대 50자입니다.',
    giftPriceRequired: '가격을 입력해 주세요.',
    giftPriceMax: '가격은 1,000,000원을 초과할 수 없습니다.',
    giftPriceMaxManage: '최대 금액은 1,000,000원입니다.',
    giftAdRequired: '광고문구를 입력해 주세요.',
    giftAdMaxLength: '기프트 설명은 최대 100자입니다.',
    giftPhotoRequired: '기프트 사진을 업로드해 주세요.',
    modifySuccess: '요청정보를 성공적으로 수정하였습니다.',
    saleStateChanged: '판매 상태가 변경되었습니다.',
    giftNameMaxChars: '최대 50자를 넘길 수 없습니다.',
    giftAdMaxChars: '최대 100자를 넘길 수 없습니다.',
    numbersOnly: '숫자만 입력해주세요.',
    countIssueRequired: '총발행수량을 입력하거나 무제한을 선택해 주세요.',
    saleEndRequired: '판매종료일을 선택하거나 무기한을 선택해 주세요.',
    selectImage: '이미지 선택',
    datePickerOnly: '달력에서만 선택 가능합니다.',
    validityFixed: '(약관에 따라 3개월로 고정)',
    searchLoadFailed: '검색 결과를 불러오지 못했습니다.',
    noSearchResult: '검색 결과가 없습니다.',
    startDate: '시작 날짜',
    endDate: '종료 날짜',
    giftPriceMin: '가격은 1,000,000원 미만이어야 합니다.',
    giftPriceUnit: '가격은 100원 단위로만 입력 가능합니다.',
    giftPriceUnitManage: '가격은 1,000,000원 미만만 입력 가능합니다.',
    giftStampDutyNotice:
      '※ 50,000원 이상 기프트는 인지세법에 따른 인지세 검토 대상이 될 수 있습니다.',
    giftAdGenerating:
      '인공지능이 기프트에 어울리는 다양한 광고문구를 생성중입니다.',
    confirmDelete: '정말 삭제 하시겠습니까?',
    storeNameRequired: '상점명을 입력해 주세요.',
    storePhoneRequired: '상점 전화번호를 입력해 주세요.',
    storeAddrRequired: '상점 주소를 입력해 주세요.',
    storeBankRequired: '입금받을 은행을 선택해 주세요.',
    storeAccountNoRequired: '입금받을 계좌번호를 입력해 주세요.',
    storeAccountNoFormat: '입금받을 계좌번호는 "-" 없이 숫자만 넣어주세요.',
    storeAccountHolderRequired: '예금주를 입력해 주세요.',
    storeBizNumFormat: '사업자등록번호는 3-2-5 자리로 입력해주세요.',
    storePhoneFormat: '휴대폰 번호를 숫자-숫자-숫자로 넣어주세요!',
    accountValidationFailed: '계좌 유효성 검증에 실패했습니다.',
    continueBusiness: '계속사업자',
    pushSendSuccess: '푸시알림이 정상적으로 전송되었습니다.',
    pushSendFail: '푸시알림 전송에 실패했습니다.',
    bizNumLabel: '사업자등록번호',
    representativeLabel: '대표자',
    addressLabel: '주소',
    storeNameLabel: '상호',
    operationHoursLabel: '고객센터 운영시간',
    serviceTerms: '서비스이용약관',
    privacyPolicy: '개인정보처리방침',
    phoneLabel: '전화번호',
    defaultRepresentative: '고승곤',
    defaultAddress:
      '인천 미추홀구 석정로 229, 811호 (도화동,인천블록체인허브센터)',
    defaultStoreName: '(주)오스리움',
    defaultOperationHours: '평일 09:00 - 18:00',
    defaultOperationHoursNote:
      '(점심시간 12:00~13:00 미운영 / 주말 및 공휴일 휴무)',
    defaultPhone: '070-4010-8203',
    poweredBy: 'Copyright by (주)오스리움. All Rights Reserved',
    usageCancel: '사용취소',
    confirmUsageCancel: '사용완료 상태를 사용전으로 되돌리시겠습니까?',
    usageCancelSuccess: '사용취소가 완료되었습니다.',
    usageCancelFailed: '사용취소에 실패했습니다.',
    smsVerifyTitle: '본인 확인 (SMS 인증)',
    smsVerifyDesc: '가입 시 등록한 휴대폰으로 인증번호를 발송합니다.',
    smsVerifySendBtn: '인증번호 받기',
    smsVerifyResendBtn: '재발송',
    smsVerifyCodePlaceholder: '인증번호 6자리 입력',
    smsVerifyConfirmBtn: '인증 확인',
    smsVerifySent: '인증번호가 발송되었습니다. 문자를 확인해 주세요.',
    smsVerifySuccess: 'SMS 인증이 완료되었습니다.',
    smsVerifyFail: '인증번호가 올바르지 않습니다. 다시 확인해 주세요.',
    smsVerifyNoMobile: '등록된 휴대폰번호가 없습니다. 관리자에게 문의하세요.',
    smsVerifySendFail: '인증번호 발송에 실패했습니다. 다시 시도해 주세요.',
  },
  en: {
    home: 'Home',
    adminLogin: 'Admin login',
    username: 'Username',
    password: 'Password',
    keepLoggedIn: 'Keep me logged in',
    login: 'Login',
    findUsername: 'Find username',
    findPassword: 'Find password',
    signUp: 'Sign up',
    mainTitle: 'Admin login',
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed.',
    userNotFound: 'User not found.',
    incorrectPassword: 'Incorrect password.',
    storeDeactivated: 'This store has been deactivated. Please contact support.',
    storeSupport: 'Store support',
    serviceIntro: 'Service introduction',
    loginMaintain: 'Keep me logged in',
    loginId: 'Username',
    loginPassword: 'Password',
    loginButton: 'Login',
    logout: 'Logout',
    myPage: 'My page',
    giftManagement: 'Gift management',
    userManagement: 'User management',
    staffManagement: 'Staff management',
    storeManagement: 'Store management',
    customerManagement: 'Customer management',
    serviceInquiry: 'Service inquiry',
    Marketing: 'Marketing Management',
    pushAlarmTestMenu: 'Push Notification Test',
    searchPeriod: 'Period',
    refundType: 'Refund type',
    refundTypeGifter: 'Buyer refund',
    refundTypeGiftee: 'Recipient refund',
    refundTypeOwner: 'Store owner refund',
    refundFilterAll: 'All',
    giftId: 'Gift id',
    descendingOrder: 'Descending order',
    ascendingOrder: 'Ascending order',
    saleQuantity: 'Sales quantity',
    state: 'State',
    beforeSale: 'Before sale',
    inSale: 'In sale',
    endSale: 'End of sale',
    saleRegister: 'Planned sale',
    saleStart: 'Sale started',
    salePause: 'Sales discontinued',
    saleEnd: 'Sale ended',
    saleCancel: 'Sale cancelled',
    registrationDate: 'Registration date',
    saleDate: 'Sale date',
    search: 'Search',
    reset: 'Reset',
    giftImage: 'Gift image',
    price: 'Price',
    remainingCount: 'Remaining count',
    totalIssued: 'Total issued',
    totalSalesAmount: 'Total sales amount',
    editOrSalesStatus: 'Edit/sales status',
    edit: 'Edit',
    giftCancelSale: 'Cancel sale',
    giftToList: 'Back to list',
    giftSave: 'Save',
    salesStatus: 'Sales Status',
    totalCount: 'Total count',
    count: 'Items',
    registerGift: 'Register gift',
    currency: 'KRW',
    stateDesc: {
      판매등록: 'Planned sale',
      판매예정: 'Planned sale',
      판매시작: 'Sale started',
      판매중지: 'Sales discontinued',
      판매일시중지: 'Sale paused',
      판매종료: 'Sale ended',
      판매취소: 'Sale cancelled',
      환불요청: 'Refund requested',
      환불완료: 'Refund completed',
      미수신: 'Not received',
      미사용: 'Unused',
      사용완료: 'Used',
      기사용오류: 'Use error',
      유효기간오류: 'Expired',
    },
    payMethodDesc: {
      토스페이: 'TossPay',
      네이버페이: 'Naver Pay',
      카카오페이: 'Kakao Pay',
      페이코: 'Payco',
      신용카드: 'Credit card',
      계좌이체: 'Bank transfer',
    },
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    changePassword: 'Change password',
    name: 'Name',
    birthday: 'Birthday',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    email: 'Email',
    requestEmailAuth: 'Request auth code',
    validateEmailAuth: 'Validate',
    phoneNumber: 'Phone number',
    requestSMSAuth: 'Request auth code',
    validateSMSAuth: 'Validate',
    address: 'Address',
    modificationDate: 'Modification date',
    userWithdrawal: 'Withdraw membership',
    cancel: 'Cancel',
    save: 'Save',
    authCode: 'Auth code',
    storeId: 'Store id',
    storeName: 'Store name',
    representativeName: 'Representative name',
    storeUsageState: 'Display status',
    storeStateTemp: 'Temporary',
    storeStatePublished: 'Published',
    storeLogo: 'Store logo/image',
    bizCertFile: 'Business Registration Certificate',
    bizCertFileUploadedLabel: 'Uploaded file',
    bizCertFileNote:
      '※ You can attach a PDF or image file (jpg, jpeg, png) up to 10MB.',
    bizCertFileSizeError:
      'Business registration file size cannot exceed 10MB.',
    storeNaverUrl: 'Naver link',
    storeKakaoUrl: 'Kakao link',
    storeInstagramUrl: 'Instagram link',
    openLink: 'Open link',
    storeBizType: 'Business type',
    storeBizTypeIndividual: 'Individual',
    storeBizTypeSoleProprietor: 'Sole proprietor',
    storeBizTypeCorporation: 'Corporation',
    storeBizNumberCheck: 'Verify business registration number',
    storeBizNumberChecking: 'Checking...',
    storeBizNumberCheckSuccess: 'Business registration lookup completed.',
    storeBizNumberCheckEmpty:
      'Please enter the business number in 3-2-5 digits.',
    storeBizNumberCheckFail:
      'Failed to verify the business number. Please try again.',
    storeBizNumberCheckRequired:
      'Please complete the business registration verification.',
    noDashPlaceholder: 'Enter digits only (no hyphen).',
    uploadFileNote:
      '※ Jpg, jpeg, gif, png files are allowed. A maximum of 1 file up to 3mb can be uploaded.',
    giftUploadFileNote:
      '※ Jpg, jpeg, gif, png files are allowed. Large photos are resized automatically. (GIF up to 3MB)',
    phoneSameAsAdmin: 'Same as admin information',
    selectBank: 'Select bank',
    bankAccountNumber: 'Bank account number',
    accountHolder: 'Account holder',
    accountValidation: 'Account verification',
    giftQR: 'Gift QR code',
    storeQrStickerCount: 'Gift QR stickers attached',
    storeAcrylicInstallCount: 'Acrylic stands installed',
    giftProductQrLabel: 'Gift product QR code',
    giftProductQrDescZero:
      '0-won festival coupon: scan opens gift detail → Get event coupon → Festival coupon box. No separate entry QR or pre-stock loading.',
    downloadQR: 'Download gift QR code',
    printQR: 'Print gift QR code',
    delete: 'Delete',
    inquiryType: 'Question type',
    questionTitle: 'Question title',
    author: 'Author',
    select: 'Select',
    title: 'Title',
    titleContent: 'Title + content',
    content: 'Content',
    public: 'Public',
    private: 'Private',
    answer: 'Answer',
    askQuestion: 'Ask question',
    no: 'No',
    questionType: 'Question type',
    qnaCategoryDesc: {
      '서비스 관련': 'Service related',
      '기프트 발행': 'Gift issuance',
      '기프트 구매선물': 'Gift purchase & present',
      '기프트 사용검증': 'Gift usage verification',
      입금: 'Deposit',
      환불: 'Refund',
      기타: 'Others',
    },
    giftName: 'Gift name',
    category: 'Category',
    giftPhoto: 'Gift photo',
    giftAd: 'Gift ad',
    salePeriod: 'Sale period',
    validityPeriod: 'Validity period',
    totalIssuedQuantity: 'Total issued quantity',
    autoTransferTime: 'Auto transfer time',
    registrationDateTime: 'Registration datetime',
    createAdText: 'Create ad text',
    giftAdSelect: 'Please select an ad text',
    giftUnlimited: 'Unlimited',
    purchaseAfter: 'After purchase',
    month: 'Month',
    day: 'Day',
    unlimited: 'Unlimited',
    usageAfter: 'After usage',
    hour: 'Hour',
    register: 'Register',
    searchCondition: '--Search condition--',
    searchConditionLabel: 'Search condition',
    searchKeyword: 'Search keyword',
    searchFieldNameDefault: 'Name (default)',
    ageGroup10s: '10s',
    ageGroup20s: '20s',
    ageGroup30s: '30s',
    ageGroup40s: '40s',
    ageGroup50plus: '50+',
    ageGroup: 'Age group',
    loading: 'Loading...',
    paymentDate: 'Payment date',
    usageDate: 'Usage date',
    depositDate: 'Deposit date',
    refundRequestDate: 'Refund request date',
    refundCompletionDate: 'Refund completion date',
    searchOrder: '--Search order--',
    paymentInfo: '--Payment method--',
    paymentMethod: 'Payment method',
    tossPay: 'TossPay',
    naverPay: 'Naver Pay',
    kakaoPay: 'Kakao Pay',
    payco: 'Payco',
    creditCard: 'Credit card',
    bankTransfer: 'Bank transfer',
    card: 'Card',
    simplePayment: 'Simple payment',
    usageInfo: '--Usage info--',
    unused: 'Unused',
    unreceived: 'Unreceived',
    paid: 'paid',
    unpaid: 'unpaid',
    completed: 'Completed',
    errorUsed: 'Error used',
    expired: 'Expired',
    depositInfo: '--Deposit info--',
    notDeposited: 'Not deposited',
    deposited: 'Deposited',
    refundInfo: '--Refund info--',
    refundRequest: 'Refund request',
    refundRequestCancel: 'Refund request cancel',
    refundCompleted: 'Refund completed',
    giftSerial: 'Gift serial',
    giftSerialOrName: 'Gift serial or product name',
    gifter: 'Gifter',
    giftee: 'Giftee',
    paymentDetails: 'Payment method',
    usageDetails: 'Usage info',
    depositDetails: 'Deposit info',
    refundDetails: 'Refund info',
    paymentAmount: 'Payment amount',
    usageAmount: 'Usage amount',
    depositAmount: 'Deposit amount',
    refundAmount: 'Refund amount',
    serviceFee: 'Service fee',
    saleAmount: 'Sale amount',
    stopReason: 'Stop reason',
    stopDateTime: 'Stop date & time',
    inputErrorStopReason: 'Input error: Please enter a stop reason',
    giftModifyDelete: 'Gift modify/delete',
    saleStartBtn: 'Start sale',
    salesStop: 'Stop sale',
    salesPauseBtn: 'Pause sale',
    salesResume: 'Resume sale',
    soldAmount: 'Total sales amount',
    soldQuantity: 'Total sales quantity',
    status: 'Status',
    salesState: 'Sales state',
    giftState: 'Gift state',
    writer: 'Writer',
    fileUpload: 'File upload',
    publicType: 'Public type',
    note: '※ This space is for collecting your valuable opinions. Please register your suggestions for the service. Posts related to commercial purposes, defamation, slander, personal information, etc. may be deleted.',
    selectCategory: {
      serviceRelated: 'Service related',
      giftIssuance: 'Gift issuance',
      giftPurchasePresent: 'Gift purchase & present',
      giftUsageVerification: 'Gift usage verification',
      deposit: 'Deposit',
      refund: 'Refund',
      others: 'Others',
      '쇼핑,유통': 'Shopping & Distribution',
      제조업: 'Manufacturing',
      '협회,단체': 'Association & Organization',
      '스포츠,오락': 'Sports & Entertainment',
      한식: 'Korean cuisine',
      '여행,명소': 'Travel & Attractions',
      음식점: 'Restaurant',
      '생활,편의': 'Living & Convenience',
      '전문,기술서비스': 'Professional & Technical Services',
      '카페,디저트': 'Cafe & Dessert',
      '서비스,산업': 'Service & Industry',
      '건강,의료': 'Health & Medical',
      '교육,학문': 'Education & Academia',
      건설업: 'Construction',
      '사회,복지': 'Social & Welfare',
      '직업,기술교육': 'Vocational & Technical Education',
      '육류,고기요리': 'Meat & Meat Dishes',
      '병원,의원': 'Hospital & Clinic',
      '스포츠,레크레이션교육': 'Sports & Recreation Education',
      '임대,대여': 'Rental & Lease',
    },
    length: 'Characters',
    quantity: 'Quantity',
    movetogiftpage: 'Go to gift page',
    movetoGiftProductPage: 'Open gift product page',
    refundHistory: 'Refund History',
    bank: 'Bank',
    accountNo: 'Account No',
    cancelPayment: 'Cancel Payment',
    total: 'Total',
    confirmRefund: 'Confirm Refund Details',
    refundAmountLabel: 'Refund Amount',
    cancelReason: 'Cancel Reason',
    cancelPaymentSuccess: 'Payment has been canceled.',
    cancelPaymentError: 'Failed to cancel payment.',
    loginExpired: 'Session expired, please log in again.',
    sortOrder: 'Sort Order',
    ascending: 'Ascending',
    descending: 'Descending',
    close: 'Close',
    pushalarm: 'Push Alarm',
    confirmSaleStart: 'Are you sure you want to start the sale?',
    confirmResume: 'Are you sure you want to resume?',
    confirmPause: 'Are you sure you want to pause?',
    giftSaleEndNoModify:
      'Gifts that have ended sale or been cancelled cannot be modified.',
    giftSaleStartDateInvalid: 'Sale start date must be today or a future date.',
    confirmModify: 'Are you sure you want to save changes?',
    confirmModifyFuture:
      'The current gift will be sold until {oldUntil} and then end,\nand the changes will go on sale from {newStart}.\nDo you want to save?',
    confirmSaleStartReplace:
      'Are you sure you want to start the sale?\nAny earlier version on sale under the same name will be cancelled.',
    confirmModifyTodayReplace:
      'With today as the sale start date, the sale starts as soon as you save.\nAny earlier version on sale under the same name will be cancelled.\nDo you want to start selling today?',
    confirmModifyToday:
      'With today as the sale start date, the changes go on sale as soon as you save,\nand the current gift will be cancelled.\nDo you want to start selling today?',
    confirmRegisterToday:
      'With today as the sale start date, the sale starts as soon as you register.\nDo you want to start selling today?',
    confirmModifyTodayWithPending:
      'With today as the sale start date, the changes go on sale as soon as you save, and the current gift will be cancelled.\nThe changes will be sold until {until}, and the reserved version goes on sale from {pendingStart}.\nDo you want to start selling today?',
    confirmCancelSale:
      'Are you sure you want to cancel the sale?\nCancelled gifts cannot be used again.',
    requestError:
      'An error occurred while processing your request. Please try again later.',
    imageSizeError: 'Image file size cannot exceed 3MB.',
    giftNameRequired: 'Please enter the gift name.',
    giftNameMaxLength: 'Gift name must be 50 characters or less.',
    giftPriceRequired: 'Please enter the price.',
    giftPriceMax: 'Price cannot exceed 1,000,000 KRW.',
    giftPriceMaxManage: 'Maximum amount is 1,000,000 KRW.',
    giftAdRequired: 'Please enter the ad copy.',
    giftAdMaxLength: 'Gift ad must be 100 characters or less.',
    giftPhotoRequired: 'Please upload a gift photo.',
    modifySuccess: 'Successfully updated.',
    saleStateChanged: 'Sales status has been changed.',
    giftNameMaxChars: 'Cannot exceed 50 characters.',
    giftAdMaxChars: 'Cannot exceed 100 characters.',
    numbersOnly: 'Please enter numbers only.',
    countIssueRequired: 'Enter the total issued quantity or select Unlimited.',
    saleEndRequired: 'Select a sale end date or select Unlimited.',
    selectImage: 'Select image',
    datePickerOnly: 'Select from the calendar only.',
    validityFixed: '(Fixed at 3 months per terms)',
    searchLoadFailed: 'Failed to load search results.',
    noSearchResult: 'No search results found.',
    startDate: 'Start date',
    endDate: 'End date',
    giftPriceMin: 'Price must be less than 1,000,000 KRW.',
    giftPriceUnit: 'Price must be in 100 KRW increments.',
    giftPriceUnitManage: 'Price must be less than 1,000,000 KRW.',
    giftStampDutyNotice:
      'Note: Gifts priced at KRW 50,000 or more may be subject to stamp tax review under applicable law.',
    giftAdGenerating: 'AI is generating ad copy for your gift.',
    confirmDelete: 'Are you sure you want to delete?',
    storeNameRequired: 'Please enter store name.',
    storePhoneRequired: 'Please enter store phone number.',
    storeAddrRequired: 'Please enter store address.',
    storeBankRequired: 'Please select a bank.',
    storeAccountNoRequired: 'Please enter account number.',
    storeAccountNoFormat: 'Enter account number without "-" (numbers only).',
    storeAccountHolderRequired: 'Please enter account holder name.',
    storeBizNumFormat: 'Enter business number as XXX-XX-XXXXX.',
    storePhoneFormat: 'Enter phone number as XXX-XXXX-XXXX.',
    accountValidationFailed: 'Account verification failed.',
    continueBusiness: 'Operating',
    pushSendSuccess: 'Push notification sent successfully.',
    pushSendFail: 'Failed to send push notification.',
    bizNumLabel: 'Business registration no.',
    representativeLabel: 'Representative',
    addressLabel: 'Address',
    storeNameLabel: 'Business name',
    operationHoursLabel: 'Customer service hours',
    serviceTerms: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    phoneLabel: 'Phone',
    defaultRepresentative: 'Ko Seungkon',
    defaultAddress:
      '229, Seokjeong-ro, Michuhol-gu, Incheon, 811 (Dohwa-dong, Incheon Blockchain Hub Center)',
    defaultStoreName: 'Authrium Co., Ltd.',
    defaultOperationHours: 'Weekdays 09:00 - 18:00',
    defaultOperationHoursNote:
      '(Closed 12:00-13:00 for lunch / Closed on weekends and holidays)',
    defaultPhone: '070-4010-8203',
    poweredBy: 'Copyright by Authrium Co., Ltd. All Rights Reserved',
    usageCancel: 'Cancel Usage',
    confirmUsageCancel: 'Are you sure you want to revert this to unused?',
    usageCancelSuccess: 'Usage has been successfully cancelled.',
    usageCancelFailed: 'Failed to cancel usage.',
    smsVerifyTitle: 'Identity Verification (SMS)',
    smsVerifyDesc: 'A verification code will be sent to your registered phone.',
    smsVerifySendBtn: 'Send Code',
    smsVerifyResendBtn: 'Resend',
    smsVerifyCodePlaceholder: 'Enter 6-digit code',
    smsVerifyConfirmBtn: 'Verify',
    smsVerifySent: 'Verification code sent. Please check your messages.',
    smsVerifySuccess: 'SMS verification completed.',
    smsVerifyFail: 'Incorrect code. Please try again.',
    smsVerifyNoMobile: 'No registered phone number. Please contact admin.',
    smsVerifySendFail: 'Failed to send verification code. Please try again.',
  },
};

export default translations;
